import RequestService from "@/services/request.service";
import { AppError } from "@/services/error.service";

const GroupService = {
  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guest%20Groups/List%20Guest%20Groups
  getAll: async function (organizationId, eventId, filters) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guest-groups/`;
      const params = filters;
      return await RequestService.get(path, params);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guest%20Groups/Retrieve%20Guest%20Group
  get: async function (organizationId, eventId, groupId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guest-groups/${groupId}/`;
      return await RequestService.get(path);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guest%20Groups/Create%20Guest%20Group
  create: async function (organizationId, eventId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guest-groups/`;
      return await RequestService.post(path, data);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guest%20Groups/Update%20Guest%20Group
  update: async function (organizationId, eventId, data) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guest-groups/${data.id}/`;
      return await RequestService.put(path, data);
    } catch (error) {
      throw new AppError(error);
    }
  },

  // https://guestlist-api.dev.olaii.com/api/schema/swagger-ui/#/Guest%20Groups/v1_organizations_events_guest_groups_destroy
  delete: async function (organizationId, eventId, groupId) {
    try {
      const path = `/api/v1/organizations/${organizationId}/events/${eventId}/guest-groups/${groupId}/`;
      return await RequestService.delete(path);
    } catch (error) {
      throw new AppError(error);
    }
  },
};

export default GroupService;
